import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import AppSidebar from "../layout/AppSidebar";
import AdminBanner from "../layout/AdminBanner";
import ChatContainer from "../layout/ChatContainer";
import CoachList from "../organisms/coach/list/CoachList";
import AdminList from "../organisms/admin/list/AdminList";
import { MyContext } from "../Context/MyContext";
import AppBanner from "../layout/AppBanner";
import { getMessageToken } from "src/services/functions/sendMessagefunction";
import moment from "moment";
import CONSTANTS from "../services/api";
import axios from "axios";
import { AdminDashboardContext } from "../Context/MyContext";

const AdminDashboard = ({ bearerToken }) => {
  const selectedUserId = Cookies.get("selected_user_id");
  const roleId = Cookies.get("roleId");
  const [selectedCoach, setSelectedCoach] = useState("");
  const [messages, setMessages] = useState([]);
  const [otherSide_status, setOtherSide_status] = useState("");
  const [lastseen, setLastSeen] = useState(null);
  const { selectedChat, setSelectedChat, socket, userId } = useContext(MyContext);
  const [onlineUserList, setOnlineUserList] = useState([]);
  const [newMessageOn, setNewMessageOn] = useState(false);
  const [somebodyIsTyping, setSomebodyIsTyping] = useState({
    reciverId: "",
    status: false,
    subscriptionID: "",
  });

  const handleSelectCoach = (id) => {
    setSelectedCoach(id);
    Cookies.set("selected_user_id", id);
  };

  const handleBackToCoaches = () => {
    setTimeout(() => {
      setSelectedCoach(null);
      setMessages([]);
      setSelectedChat(null);
    }, 500);
  };

  // Fucntion is used for set new-message on data into correct format
  function setDataToLocalDB(data,sameCoach = false) {
    const messageToken = getMessageToken();
    const providedTimestampInMicroseconds = messageToken;
    const providedTimestampInMilliseconds = providedTimestampInMicroseconds / 1000;
    const formattedTime = moment(providedTimestampInMilliseconds).format("hh:mm a");
    let obj;
    obj = {
      _id: data._id,
      messageId: data.messageId,
      fileName: "",
      filePath: "",
      fileOriginalName: "",
      fileExtension: "",
      senderName: "",
      roomId: "",
      roomName: "",
      chatName: "",
      DateFormated: data.DateFormated,
      audioDuration: data.audioDuration,
      author: data.author.toString(),
      senderId: data.senderId,
      participantsIds: data.participantsIds,
      enrollmentId: data.enrollmentId,
      authorName: data.authorName,
      content: data.message,
      isDeleted: data.isDeleted,
      messageTime: messageToken,
      timeFormated: formattedTime,
      type: data.type,
      chatType: data.chatType,
      offline: data.offline,
      hasAttachments: false,
      thumbnail: data.thumbnail,
      sendOnServer: true,
      replyMessage: data.replyMessage?.length > 0 ? [data.replyMessage[0]] : [],
    };
    if(sameCoach){
       obj = {...obj,isRead: data.isRead}
    }else {
      obj = {...obj,isRead: true}
    }
    return obj;
  }

  //use for get the last seen time of participant
  async function getLastSeenTime() {
    try {
      const showChat = JSON.parse(localStorage.getItem("showChat"));
      socket.emit("get-timestamp",{
        user_id: showChat?.user_id
        || 65452,
      })
      // setLastSeen(data.data.chat_last_seen);
      // setOtherSide_status("leave");
    } catch (error) {
      console.log("Error ::::", error);
    }
  }
  //use for set the last seen time of current user
  async function setLastSeenTime() {
    try {
      const currentDate = moment();

      // Format the date and time
      const formatedDate = currentDate.format("YYYY-MM-DD HH:mm:ss");
      const { data } = await axios.post(
        `${CONSTANTS.API_BASE}/update-timestamp`,
        {
          timestamp: formatedDate,
        },
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            Authorization: bearerToken ? bearerToken : CONSTANTS.BearerToken,
          },
        }
      );
    } catch (error) {
      console.log("Error ::::", error);
    }
  }

  const sendTypingOffSignal = () => {
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    let options;
    if (roleId === "1") {
      options = {
        roomId: "",
        receiverId: [showChat?.coach_id, showChat?.user_id],
        userId: userId,
        typing: false,
        chatType: 1,
        subscriptionID: showChat?._id,
      };
    } else {
      options = {
        roomId: "",
        receiverId: [String(showChat?.user_id)],
        userId: userId,
        typing: false,
        chatType: 1,
        subscriptionID: String(showChat?._id),
      };
    }
    socket.emit("typing", options);
    setSomebodyIsTyping({ reciverId: "", status: false, subscriptionID: "" });
  };

  // This function is used for sendTypingStatus if user is typing
  const sendTypingOnSignal = () => {
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    let options;
    if (roleId === "1") {
      options = {
        roomId: "",
        receiverId: [showChat?.coach_id, showChat?.user_id],
        userId: userId,
        typing: true,
        chatType: 1,
        subscriptionID: showChat?._id,
      };
    } else {
      options = {
        roomId: "",
        receiverId: [String(showChat?.user_id)],
        userId: userId,
        typing: true,
        chatType: 1,
        subscriptionID: String(showChat?._id),
      };
    }
    socket.emit("typing", options);
  };

  useEffect(() => {
    setLastSeenTime();
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    if (onlineUserList.length > 0 && onlineUserList.includes(showChat?.user_id)) {
      setOtherSide_status("join");
    } else {
      getLastSeenTime();
    }
  }, [selectedChat]);

  //new-message on
  useEffect(() => {
    
    socket.on("new-message", (msg) => {
      const getMessageFromLocalState = JSON.parse(localStorage.getItem("my-message"));
      const showChat = JSON.parse(localStorage.getItem("showChat"));
      // if (!(String(showChat?._id) === String(msg.enrollmentId))) {
      //   setNewMessageOn((prev) => {
      //     return !prev;
      //   });
        
      // }
      if (showChat && String(showChat?._id) === String(msg.enrollmentId)) {
        if (roleId != "1") {
          if (msg.participantsIds.includes(String(userId))) {
            const readDetail = {
              messageId: msg.conversationId,
              isRead: true,
              userId: userId,
              enrollment_id: String(showChat?._id),
              participantsId: String(showChat?.user_id),
            };
            socket.emit("read-message", readDetail);
            const receiveMsg = setDataToLocalDB(msg);
            localStorage.setItem("my-message",JSON.stringify([receiveMsg,...getMessageFromLocalState]))
            setMessages((prev) => {
              return [...prev, receiveMsg];
            });
          } else {
            const existMessage = getMessageFromLocalState.findIndex((message) => message._id === msg._id);
            if(existMessage == -1) { 
              const receiveMsg = setDataToLocalDB(msg,true);
              localStorage.setItem("my-message",JSON.stringify([receiveMsg,...getMessageFromLocalState]))
              setMessages((prev) => {
                return [...prev, receiveMsg];
              });
            }else {
              setMessages((prevMessages) => prevMessages.map((msgs) => (msgs.messageId === "" ? { ...msgs, messageId: msg.messageId } : msgs)));
            }
            
          }
        } else {
          // if the user is superAdmin then it can't read the msg
          if (roleId == "1" && selectedUserId) {
            if (msg.participantsIds.includes(selectedUserId) && msg.participantsIds.includes(String(showChat?.user_id))) {
              setMessages((prevMessages) => prevMessages.map((msgs) => (msgs.messageId === "" ? { ...msgs, messageId: msg.messageId } : msgs)));
            } else {
              const receiveMsg = setDataToLocalDB(msg);
              localStorage.setItem("my-message",JSON.stringify([receiveMsg,...getMessageFromLocalState]))
              setMessages((prev) => {
                return [...prev, receiveMsg];
              });
            }
          }
        }
      }
      if (!(String(showChat?._id) === String(msg.enrollmentId))) {
        setNewMessageOn((prev) => {
          return !prev;
        });
      }
    });
    socket.on("delete-message", (msg) => {
      console.log("delete-message-on >>>", msg);
    });
    //******* read-message on **************
    socket.on("read-message", (res) => {
      const showChat = JSON.parse(localStorage.getItem("showChat"));
      if (res && String(res.enrollment_id) === String(showChat?._id)) {
        setMessages((prevMessages) => prevMessages.map((msg) => (msg.isRead === false ? { ...msg, isRead: true } : msg)));
      }
    });

    //*******online-user on ****************
    socket.on("online-user", (res) => {
      setOnlineUserList(res);
      const showChat = JSON.parse(localStorage.getItem("showChat"));
      if (res.length > 0 && res.includes(showChat?.user_id)) {
        setOtherSide_status("join");
      } else {
        getLastSeenTime();
      }
    });
    // offine-user on
    socket.on("offline-user", (res) => {
      setOnlineUserList(res);
      const showChat = JSON.parse(localStorage.getItem("showChat"));
      if (showChat) {
        if (res.length > 0 && res.includes(showChat?.user_id)) {
          setOtherSide_status("join");
        } else {
          getLastSeenTime();
        }
      }
    });
    // ********** typing message on **********
    socket.on("typing", (res) => {
      setSomebodyIsTyping({
        reciverId: res.receiverId,
        status: res.typingStatus,
        subscriptionID: res.subscriptionID,
      });
    });
    socket.on("get-timestamp",(data) => {
      setLastSeen(data.data.chat_last_seen);
      setOtherSide_status("leave");
    })
  }, [socket]);

  useEffect(() => {
    setMessages([]);
  }, [selectedChat]);

  return (
    <div className="flex flex-col md:flex-row   justify-between gap-x-14">
      <AdminDashboardContext.Provider
        value={{
          messages,
          setMessages,
          otherSide_status,
          lastseen,
          sendTypingOnSignal,
          sendTypingOffSignal,
          somebodyIsTyping,
          selectedCoach,
          newMessageOn,
          setNewMessageOn,
          onlineUserList,
        }}
      >
        <AppSidebar onBack={handleBackToCoaches}>
          {(roleId === "1" || roleId === "6" || roleId === "7") ? (
            selectedCoach ? (
              bearerToken ? (
                <CoachList onBack={handleBackToCoaches} bearerToken={bearerToken} />
              ) : null
            ) : bearerToken ? (
              <AdminList onSelectCoach={handleSelectCoach} bearerToken={bearerToken} />
            ) : null
          ) : bearerToken ? (
            <CoachList onBack={handleBackToCoaches} bearerToken={bearerToken} />
          ) : null}
        </AppSidebar>
        {(roleId === "1" || roleId === "6" || roleId === "7") ? selectedCoach ? selectedChat ? <ChatContainer /> : <AppBanner /> : <AdminBanner /> : selectedChat ? <ChatContainer /> : <AppBanner />}
      </AdminDashboardContext.Provider>
    </div>
  );
};

export default AdminDashboard;
